export default __webpack_public_path__ + "static/media/general-add-ons.34a78508.svg";